import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as c from '../constant';
import * as actions from '../action';

function DisabilityModal({
  createDisability,
  history,
  showDisability,
  creating,
  type,
  updateDisability,
  dataInfo,
  dataId,
  getDisabilityList
}) {
  const [formData, setFormData] = useState({
    code: '',
    name: '',
    is_active: 0,
  });

  const validateForm = useFormValidator(formData, {
    code: 'required',
    name: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();
    if (!validateForm.response.is_passed) {
      return false;
    }

    if (type === 'NEW') {
      return createDisability(formData, ({ data }) => {
        setModal({ isOpen: false });
        history.push(`/social-ameliorations/settings/pwd/disability/${+_.get(data, 'id')}`);
        getDisabilityList();
        showDisability(+data.id);
      });
    }

    return updateDisability(dataId, formData, ({ data }) => {
      setModal({ isOpen: false });
      history.push(`/social-ameliorations/settings/pwd/disability/${+_.get(data, 'id')}`);
      getDisabilityList();
      showDisability(+data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(','), formData]);

  const OnSetFormData = () => {
    setFormData({
      name: _.get(dataInfo, 'name') || '',
      code: _.get(dataInfo, 'code') || '',
      is_active: _.get(dataInfo, 'is_active') || '',
    });
  };

  useEffect(() => {
    if (!_.isEmpty(dataInfo)) {
      OnSetFormData();
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Code {validateForm.renderMessage('code')}
            </label>
            <input
              className="form-control"
              type="text"
              min="3"
              name="code"
              onChange={onChange}
              value={_.get(formData, 'code') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              min="3"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}
DisabilityModal.defaultProps = {
  type: '',
  dataInfo: {},
  dataId: '',
};

DisabilityModal.propTypes = {
  getDisabilityList: PropTypes.instanceOf(Function).isRequired,
  createDisability: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showDisability: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
  type: PropTypes.string,
  updateDisability: PropTypes.instanceOf(Function).isRequired,
  dataInfo: PropTypes.instanceOf(Object),
  dataId: PropTypes.string,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_DISABILITY) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(DisabilityModal);
